import {
    faCircleCheck,
    faTimesCircle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Flex } from "@chakra-ui/react";

import { Text } from "@components/Text";

interface PropTypes {
    isActive?: boolean;
    text: string;
    isTextUnderLine?: boolean;
    notUnderlineText?: string;
}

const Feature = ({
    isActive = false,
    text,
    isTextUnderLine = false,
    notUnderlineText
}: PropTypes) => {
    let iconColor = "var(--euka-colors-sunsetRed-500)";
    if (isActive) iconColor = "var(--euka-colors-green-400)";

    return (
        <Flex gap={2}>
            <Flex as="span" height="30px" align="center" alignSelf="flex-start">
                <FontAwesomeIcon
                    icon={isActive ? faCircleCheck : faTimesCircle}
                    color={iconColor}
                    fontSize={14}
                />
            </Flex>

            {isTextUnderLine && text && !notUnderlineText && (
                <Text fontSize={14} textDecoration="underline">
                    {text}
                </Text>
            )}
            {!isTextUnderLine && !notUnderlineText && text && (
                <Text fontSize={14}>{text}</Text>
            )}
            {isTextUnderLine && notUnderlineText && text && (
                <>
                    <Text fontSize={14}>
                        <span
                            style={{
                                textDecoration: "underline",
                                textUnderlineOffset: "4px"
                            }}
                        >
                            {text}{" "}
                        </span>
                        {notUnderlineText}
                    </Text>
                </>
            )}
        </Flex>
    );
};

export default Feature;
